import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { MainLayout } from '../components/Layout';
import LookerStudioEmbed from '../components/dashboard/LookerStudioEmbed';
import DashboardContent from '../components/dashboard/DashboardContent';
import MBFDashboard from './MBFDashboard';
import TLDashboardContent from '../components/dashboard/TLDashboardContent';
import OrgAllStatsAPIs from '../utilities/api/dashboard/OrgAllStatsAPIs';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import AdminUserDetail from '../utilities/api/user/AdminUserDetail';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

const Dashboard = ({ collapsed, setCollapsed }) => {
  const { user } = useSelector(state => state.user.user); // Retrieve user from Redux store

  const navigate = useNavigate();
  const [frtDialogOpen, setFrtDialogOpen] = useState(false);
  const [frtStatus, setFrtStatus] = useState(null);

  useEffect(() => {
    const checkFrtStatus = async () => {
      try {
        const response = await AdminUserDetail.AdminDetailGetFRTStatus();
        console.log('FRT Status on Dashboard:', response);

        // Show dialog if status is Failed and image_required is true
        if (response.status === 'Failed' && response.image_required) {
          setFrtStatus(response);
          setFrtDialogOpen(true);
        }
        // Show dialog if status is Not added and image_required is true
        else if (response.status === 'Not added' && response.image_required) {
          setFrtStatus(response);
          setFrtDialogOpen(true);
        }
      } catch (error) {
        console.error('Error fetching FRT status on dashboard:', error);
      }
    };

    checkFrtStatus();
  }, []);

  const handleCloseFrtDialog = () => {
    setFrtDialogOpen(false);
  };

  const handleUploadAction = () => {
    // Handle upload/re-upload functionality here
    console.log('Upload action clicked');
    navigate('/re-upload-instructions');
    // You can add navigation to profile or upload functionality here
    setFrtDialogOpen(false);
  };
  // console.log('Dashboard User',user);

  return (
    <>
      {user.TL_name === 'MBF Admin' ? (
        <MBFDashboard collapsed={collapsed} setCollapsed={setCollapsed} />
      ) : (
        <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
          <TLDashboardContent setCollapsed={setCollapsed} />
          <Box sx={{ display: 'none' }}>
            <Dialog
              open={frtDialogOpen}
              onClose={handleCloseFrtDialog}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle
                sx={{
                  backgroundColor:
                    frtStatus?.status === 'Failed' ? '#d32f2f' : 'rgb(39,63,119)',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                {frtStatus?.status === 'Failed'
                  ? '❌ FRT Image Failed'
                  : '📷 FRT Image Required'}
              </DialogTitle>
              <DialogContent sx={{ padding: '1.5rem' }}>
                {frtStatus?.status === 'Failed' ? (
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: '1rem',
                        color: '#d32f2f',
                        textAlign: 'center',
                      }}
                    >
                      FRT Image Verification Failed
                    </Typography>

                    {frtStatus.failed_reason && (
                      <Box
                        sx={{
                          backgroundColor: '#ffebee',
                          padding: '1rem',
                          borderRadius: '8px',
                          border: '1px solid #ffcdd2',
                          marginBottom: '1rem',
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 'bold',
                            color: '#d32f2f',
                            marginBottom: '0.5rem',
                          }}
                        >
                          Reason for Failure:
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#d32f2f' }}>
                          {frtStatus.failed_reason}
                        </Typography>
                      </Box>
                    )}

                    <Typography
                      variant="body1"
                      sx={{ textAlign: 'center', marginBottom: '1rem' }}
                    >
                      Please re-upload your image to continue using the system.
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: '1rem',
                        color: 'rgb(39,63,119)',
                        textAlign: 'center',
                      }}
                    >
                      No FRT Image Found
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ textAlign: 'center', marginBottom: '1rem' }}
                    >
                      No image has been added till now. Please add your image to
                      continue using the system.
                    </Typography>
                  </Box>
                )}
              </DialogContent>
              <DialogActions
                sx={{ padding: '1rem', justifyContent: 'center', gap: 2 }}
              >
                <Button
                  variant="contained"
                  // startIcon={<span>📷</span>}
                  onClick={handleUploadAction}
                  sx={{
                    backgroundColor:
                      frtStatus?.status === 'Failed' ? '#d32f2f' : 'rgb(39,63,119)',
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor:
                        frtStatus?.status === 'Failed'
                          ? '#b71c1c'
                          : 'rgb(29,53,109)',
                    },
                  }}
                >
                  {frtStatus?.status === 'Failed'
                    ? 'Re-Upload Image'
                    : 'Upload Image'}
                </Button>
                <Button
                  onClick={handleCloseFrtDialog}
                  variant="outlined"
                  sx={{
                    color: 'rgb(39,63,119)',
                    borderColor: 'rgb(39,63,119)',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    textTransform: 'none',
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </MainLayout>
      )}
    </>
  );
};

export default Dashboard;
